import { CONFERENCE_FAILED, CONFERENCE_JOINED, LOCK_STATE_CHANGED, SET_PASSWORD_FAILED } from '../base/conference/actionTypes';
import { hideDialog } from '../base/dialog/actions';
import { JitsiConferenceErrors } from '../base/lib-jitsi-meet';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { showErrorNotification, showNotification } from '../notifications/actions.any';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { setPassword } from '../base/conference/actions.any';
import PasswordRequiredPrompt from './components/PasswordRequiredPrompt';
import { LOCKED_REMOTELY } from './constants';
import logger from './logger';
/**
 * Middleware that captures conference failed and checks for password required
 * error and requests a dialog for user to enter password.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case CONFERENCE_FAILED:
            return _conferenceFailed(store, next, action);
        case CONFERENCE_JOINED:
            return _conferenceJoined(store, next, action);
        case LOCK_STATE_CHANGED: {
            const previousLockedState = store.getState()['features/base/conference'].locked;
            const result = next(action);
            const currentLockedState = store.getState()['features/base/conference'].locked;
            if (currentLockedState === LOCKED_REMOTELY) {
                // store.dispatch(
                //     showNotification({
                //         titleKey: 'notify.passwordSetRemotely'
                //     }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
            }
            else if (previousLockedState === LOCKED_REMOTELY && !currentLockedState) {
                store.dispatch(showNotification({
                    titleKey: 'notify.passwordRemovedRemotely'
                }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
            }
            return result;
        }
        case SET_PASSWORD_FAILED:
            return _setPasswordFailed(store, next, action);
    }
    return next(action);
});
/**
 * Handles cleanup of lock prompt state when a conference is joined.
 *
 * @param {Store} store - The redux store in which the specified action is being
 * dispatched.
 * @param {Dispatch} next - The redux {@code dispatch} function to dispatch the
 * specified action to the specified store.
 * @param {Action} action - The redux action {@code CONFERENCE_JOINED} which
 * specifies the details associated with joining the conference.
 * @private
 * @returns {*}
 */
function _conferenceJoined({ dispatch }, next, action) {
    dispatch(hideDialog(PasswordRequiredPrompt));
    return next(action);
}
/**
 * Handles errors that occur when a conference fails.
 *
 * @param {Store} store - The redux store in which the specified action is being
 * dispatched.
 * @param {Dispatch} next - The redux {@code dispatch} function to dispatch the
 * specified action to the specified store.
 * @param {Action} action - The redux action {@code CONFERENCE_FAILED} which
 * specifies the details associated with the error and the failed conference.
 * @private
 * @returns {*}
 */
function _conferenceFailed({ dispatch, getState }, next, action) {
    const { conference, error } = action;
    if (conference && error.name === JitsiConferenceErrors.PASSWORD_REQUIRED) {
        // XXX The feature room-lock affords recovery after CONFERENCE_FAILED
        // caused by JitsiConferenceErrors.PASSWORD_REQUIRED.
        if (typeof error.recoverable === 'undefined') {
            error.recoverable = true;
        }
        if (error.recoverable) {
            // [NOTE] requirePassword
            // dispatch(_openPasswordRequiredPrompt(conference));
            // try {
            //     if (i18next.isInitialized) {
            //         console.log('111', i18next.t('dialog.incorrectRoomLockPassword'))
            //         // Toast.show({
            //         //     text1: i18next.t('dialog.incorrectRoomLockPassword')
            //         // })
            //     }
            // } catch(error) {
            //     console.error(error);
            // }
            // dispatch(disconnect())
            const { password } = getState()['features/base/conference'];
            setTimeout(() => {
                dispatch(setPassword(conference, conference.join, password));
            }, 1000);
            // rootNavigationRef.current?.navigate(SCREEN_KEYS.PRE_JOIN)
            // Toast.show({ text1: t('dialog.incorrectRoomLockPassword') })
            // = getState()['features/base/conference'];
            // setTimeout(() => {
            //     console.log('setPassword')
            //     dispatch(setPassword(conference, conference.join, password))
            // }, 1000);
        }
    }
    else {
        dispatch(hideDialog(PasswordRequiredPrompt));
    }
    return next(action);
}
/**
 * Handles errors that occur when a password fails to be set.
 *
 * @param {Store} store - The redux store in which the specified action is being
 * dispatched.
 * @param {Dispatch} next - The redux {@code dispatch} function to dispatch the
 * specified action to the specified store.
 * @param {Action} action - The redux action {@code SET_PASSWORD_ERROR} which
 * has the error type that should be handled.
 * @private
 * @returns {*}
 */
function _setPasswordFailed(store, next, action) {
    if (typeof APP !== 'undefined') {
        // TODO Remove this logic when displaying of error messages on web is
        // handled through react/redux.
        const { error } = action;
        let descriptionKey;
        let titleKey;
        if (error === JitsiConferenceErrors.PASSWORD_NOT_SUPPORTED) {
            logger.warn('room passwords not supported');
            descriptionKey = 'dialog.passwordNotSupported';
            titleKey = 'dialog.passwordNotSupportedTitle';
        }
        else {
            logger.warn('setting password failed', error);
            descriptionKey = 'dialog.lockMessage';
            titleKey = 'dialog.lockTitle';
        }
        APP.store.dispatch(showErrorNotification({
            descriptionKey,
            titleKey
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    }
    return next(action);
}
